import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import pencil from '../../icons/pencil.svg';
import { connect } from 'react-redux';
import 'swiper/swiper-bundle.min.css';
import { Navigation } from 'swiper';
import Image from 'app/Components/Shared/Image/image';
function ProductsSwiper(props) {
  const products = props.banList;
  const isShowOnProduct = products.length == 1 || (products.length == 2 && products?.some(product => !product.cycle_date));
  const isNavigationEnabled = products.length > 3;

  if(products?.length == 0){
    return null;
  }

  const onClickBan = (product) => {
    props.onClickBan(product);
  };

  function getProductName(productsList) {
    const productName = (product) => {
      switch (product) {
        case 'CELLULAR':
          return 'סלולר';
        case 'INTERNET':
          return 'אינטרנט';
        case 'TV':
          return 'TV';
        case 'MAPA':
          return 'טלפון';
        case 'ENERGY':
          return 'חשמל';
        default:
          return null;
      }
    };
    return productsList?.map(product => productName(product)).filter(x => x!=null ).join(' + ');
  }

  return (
    <div className={`wrapper-swiper-products ${props.isSticky ? 'sticky' : ''} ${props.isAuthorizationHeader ? 'is-authenticated' : ''}`}>
      {products?.length >= 1 &&
        <div className='container-swiper-products'>
          <Swiper
            className={`${isShowOnProduct ? 'one-product' : ''} ${!isNavigationEnabled ? 'centered-slides' : ''}`}
            initialSlide={products.findIndex(product => product.guidId === props.selectedBan.guidId)}
            slidesPerView={'auto'}
            spaceBetween={24}
            modules={[Navigation]}
            navigation={ isNavigationEnabled  ? {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            } : false}
            breakpoints={{
              200: {  // when window width is >= 200px
                allowTouchMove: products?.length > 1 ? true : false,
                spaceBetween: 10,
                slidesPerView: products?.length > 1 ? 'auto' : 1,
              },
              600: { // when window width is >= 600px
                spaceBetween: 24,
                allowTouchMove: true,
              },
            }}
          >
          {products?.map((product, i) =>{
          const isSelected = product.guidId === props.selectedBan.guidId;
            return(
            <SwiperSlide
              key={i}
              className={`${isSelected? 'selected' : 'unselected'} ${!product.cycle_date? 'button-show-invoices' : ''}`}>
              {product.cycle_date ?
                <div className='detailsSquare' onClick={() => onClickBan(product)}>
                  {product.isBusiness && (<div className='tag'>עסקי</div>)}
                  <div className='data-square'>
                    <div className='text-product'>{getProductName(product.listServices)}</div>
                    {/* <div className='price-product'>{product.invoivePrice?.price}<span className='nis'>₪</span></div> */}
                    <div className='price-product'>
                      {product.invoivePrice?.amount}.{product.invoivePrice?.amountAgorot}
                      {product.invoivePrice?.isAmountMinus && <div className='price-range'>-</div>}
                      <span className='nis'>₪</span>
                      </div>
                  </div>
                  <div className={`${isSelected ? 'arrow' : ''}`}></div>
                </div> :
                <div className='wrapper-many-invoices'>
                  <div role='button' tabIndex='0' className='many-invoices' onClick={() => onClickBan(null)}>
                    <div className='text'>
                      <span>לצפייה בכל החשבוניות</span>
                      <Image src={require('./images/keyboard-double-arrow-left.svg')} className='text-icon' alt='keyboard-double-arrow-left' />
                    </div>
                  </div>
                </div>
              }
            </SwiperSlide>)
          })}
          {isNavigationEnabled &&
          <><div className="swiper-button-next">
            <Image src={require('./images/expand-circle-right.svg')} className='swiper-button-next-icon' alt='expand-circle-right' />
          </div>
          <div className="swiper-button-prev">
            <Image src={require('./images/expand-circle-right.svg')} className='swiper-button-prev-icon' alt='expand-circle-right' />
          </div>
          </>}
        </Swiper>
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loginData: state.authentication.loginData,
  };
};
const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsSwiper);
